<script setup lang="ts">
import { getBlogCategories } from "~/api/blog";

const emit = defineEmits(["setCategories"]);
const categories = ref<any>([]);
const selected = ref(null);

const fetchDDCategories = async () => {
  try {
    const { status, data } = await getBlogCategories();
    if (status) {
      categories.value = data;
    }
  } catch (error) {
    console.error("Error fetching blog categories:", error);
  }
};

fetchDDCategories();

const setCategory = (id: any) => {
  selected.value = id;
  emit("setCategories", id);
};

const activeCategories = (id: any) => {
  return selected.value === id
    ? "bg-primary rounded-xl px-4 py-1 text-white text-xs"
    : "text-sm";
};
</script>

<template>
  <div class="flex overflow-x-auto whitespace-nowrap items-center gap-6 mb-4">
    <div
      class="cursor-pointer shrink-0"
      :class="
        selected === null
          ? 'bg-primary rounded-xl px-4 py-1 text-white text-xs'
          : 'text-sm'
      "
      @click="setCategory(null)"
    >
      All
    </div>
    <div
      v-for="(category, index) in categories"
      :key="index"
      class="cursor-pointer shrink-0"
      :class="activeCategories(category.id)"
      @click="setCategory(category.id)"
    >
      {{ category.category }}
    </div>
  </div>
</template>
